import type { BlogPosting, Message, ProductName } from '@/types/discover';
import type { MonthlySales } from '@/types/statistics';
import { membershipDashboardOrderStatusSummary } from '@/components/membership/membership-order-preview-mock';
import {
  membershipInquiryPreviewCounts,
  membershipReviewPreviewCounts,
} from '@/pages/orders/_components/membership-review-inquiry-mock';

const newsTitles = [
  'G마켓·옥션, 판매 혁신 클럽 회원 전용 AI 투자존 셀러 지원 대폭 강화',
  '쇼케이스 급증, 높은 제품 상품 주요 공급...기상 변화 대응이 관건',
  '화물 급등에 해외직구 위축...국내 판매상품 가격 전략이 중요해져요',
  '편의점 신선식품·소포장 장보기 트렌드, 1~2인 가구 공략이 기회',
  '젊은 소비자 잡아라, 건강식품 시장이 달라지고 있어요',
];

export const membershipDashboardMock = {
  todaySummary: {
    formattedNow: '2026.05.04 11:29:39',
    totalSalesAmount: 523_400,
    totalRevenueAmount: 492_000,
    totalSalesCount: 29,
  },
  orderFilterLabel: '최근 7일',
  orderStatusSummary: membershipDashboardOrderStatusSummary,
  activitySummary: {
    newReviewCount: membershipReviewPreviewCounts.total,
    newInquiryCount: membershipInquiryPreviewCounts.notYet,
  },
  salesDiffAmount: 293_536,
  monthlySalesList: [
    {
      FirstDayOfMonth: '2026-03-01T00:00:00',
      Month: '2026-03',
      SalesAmount: 3_350_504,
      SalesAmountUntilDay: 3_350_504,
    },
    {
      FirstDayOfMonth: '2026-04-01T00:00:00',
      Month: '2026-04',
      SalesAmount: 3_600_000,
      SalesAmountUntilDay: 3_600_000,
    },
    {
      FirstDayOfMonth: '2026-05-01T00:00:00',
      Month: '2026-05',
      SalesAmount: 3_450_000,
      SalesAmountUntilDay: 3_450_000,
    },
    {
      FirstDayOfMonth: '2026-06-01T00:00:00',
      Month: '2026-06',
      SalesAmount: 4_000_000,
      SalesAmountUntilDay: 4_000_000,
    },
    {
      FirstDayOfMonth: '2026-07-01T00:00:00',
      Month: '2026-07',
      SalesAmount: 4_600_000,
      SalesAmountUntilDay: 4_600_000,
    },
    {
      FirstDayOfMonth: '2026-08-01T00:00:00',
      Month: '2026-08',
      SalesAmount: 3_700_000,
      SalesAmountUntilDay: 3_700_000,
    },
    {
      FirstDayOfMonth: '2026-09-01T00:00:00',
      Month: '2026-09',
      SalesAmount: 3_644_040,
      SalesAmountUntilDay: 3_644_040,
    },
  ] satisfies MonthlySales[],
  blogList: [
    {
      CategoryPublicName: '인기 키워드',
      ThmubnailUrl: '/images/dashboard-mock/blog-1.png',
      Title: '소비자 키워드, 인기검색어',
      Url: 'https://blog.sellerbox.io/',
    },
    {
      CategoryPublicName: '어디서 시작할까요?',
      ThmubnailUrl: '/images/dashboard-mock/blog-2.png',
      Title: '자체쇼핑몰 구축플랫폼 업체 비교',
      Url: 'https://blog.sellerbox.io/',
    },
    {
      CategoryPublicName: '어디서 시작할까요?',
      ThmubnailUrl: '/images/dashboard-mock/blog-3.png',
      Title: '자체쇼핑몰 구축플랫폼 업체 비교',
      Url: 'https://blog.sellerbox.io/',
    },
    {
      CategoryPublicName: '어디서 시작할까요?',
      ThmubnailUrl: '/images/dashboard-mock/blog-4.png',
      Title: '자체쇼핑몰 구축플랫폼 업체 비교',
      Url: 'https://blog.sellerbox.io/',
    },
  ] satisfies BlogPosting[],
  sellerboxAi: {
    makeName: {
      messages: [
        {
          id: 0,
          text: '키워드와 상품 특징을 입력해보세요.\nAI가 상품명을 만들어드려요.\n예시) 인테리어 블루투스 스피커',
          sender: 'bot',
        },
        {
          id: 1,
          text: '무드등 블루투스 스피커',
          sender: 'user',
        },
        {
          id: 2,
          text: '감성 무드등 블루투스 스피커',
          sender: 'bot',
          remainCount: 4,
        },
      ] satisfies Message[],
      productNameList: [
        { product_name: '감성 무드등 블루투스 스피커' },
        { product_name: '침실 인테리어 LED 블루투스 스피커' },
        { product_name: '무선 충전 무드라이트 블루투스 스피커' },
        { product_name: '캠핑용 휴대용 무드등 스피커' },
        { product_name: '선물용 LED 조명 블루투스 스피커' },
      ] satisfies ProductName[],
    },
    changeName: {
      messages: [
        {
          id: 0,
          text: '도매몰 또는 해외 상품명을 붙여넣어보세요.\nAI가 알맞은 상품명으로 바꿔드려요.',
          sender: 'bot',
        },
        {
          id: 1,
          text: 'Portable Mini Bluetooth Speaker with LED Light',
          sender: 'user',
        },
        {
          id: 2,
          text: '휴대용 LED 무드등 블루투스 스피커',
          sender: 'bot',
          subText: '검색 의도와 상품 특징이 잘 드러나도록 핵심 키워드를 앞쪽에 배치했어요.',
          list: ['휴대용', 'LED 무드등', '블루투스 스피커'],
          remainCount: 4,
        },
      ] satisfies Message[],
      productNameList: [
        {
          product_name: '휴대용 LED 무드등 블루투스 스피커',
          Consideration: '검색 의도와 상품 특징이 잘 드러나도록 핵심 키워드를 앞쪽에 배치했어요.',
          Keywords: ['휴대용', 'LED 무드등', '블루투스 스피커'],
        },
        {
          product_name: '캠핑용 미니 LED 블루투스 스피커',
          Consideration: '활용 상황과 크기감을 함께 보여주도록 조정했어요.',
          Keywords: ['캠핑용', '미니', 'LED 스피커'],
        },
        {
          product_name: '침실 무드등 겸용 블루투스 스피커',
          Consideration: '사용 공간과 겸용 기능을 강조했어요.',
          Keywords: ['침실', '무드등', '겸용'],
        },
        {
          product_name: '무선 LED 조명 블루투스 스피커',
          Consideration: '주요 기능을 간결하게 정리했어요.',
          Keywords: ['무선', 'LED 조명', '블루투스'],
        },
        {
          product_name: '선물용 감성 LED 블루투스 스피커',
          Consideration: '구매 목적과 감성 키워드를 보강했어요.',
          Keywords: ['선물용', '감성', 'LED'],
        },
      ] satisfies ProductName[],
    },
  },
  newsBriefing: {
    date: '2026-05-04T00:00:00+09:00',
    ecommerceTopicList: newsTitles.map((title) => ({
      title,
      summary:
        '최근 이커머스 시장 변화가 빨라지고 있어요. 판매자는 가격, 재고, 배송 데이터를 함께 보면서 빠르게 대응할 필요가 있어요.',
      sellerPoints: [
        '매출과 주문 변화가 큰 상품을 먼저 확인해보세요.',
        '배송 지연이나 문의 증가가 있는 마켓을 우선 점검하세요.',
      ],
      sources: [
        {
          press: '셀러박스 리서치',
          url: 'https://blog.sellerbox.io/',
        },
      ],
      keyword: [],
      keywordCount: {},
    })),
  },
};
